import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Row, Radio } from 'antd';
import SearchList from '../../util/SearchList';
import RadioSort from '../../util/RadioSort';

@inject('caseListStore', 'listStore',)
@observer
class App extends React.Component {
  static defaultProps = {
		prefixCls: 'case-search',
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // const { caseListStore: { getTagsList } } = this.props;
    // getTagsList();
  }
  getParams = () => {
    const { caseListStore: { searchFormValue } } = this.props;
    let _searchFormValue = {...toJS(searchFormValue)};
    Object.keys(_searchFormValue).map(
      key => {
        _searchFormValue[key] || delete _searchFormValue[key]
      }
    )
    return _searchFormValue;
  }
  onSearch = () => {
    const { caseListStore: { getCaseList, params }, demotype } = this.props;
    getCaseList({
      ...toJS(params),
      ...this.getParams(),
      demotype: demotype || "default",
    });
  }
  
  onReset = () => {
    const { caseListStore: { clearSearchValue } } = this.props;
    clearSearchValue();
    this.onSearch();
  }

  handleSelectChange = (value, key) => {
    const { onChange, caseListStore: { searchFormValue } } = this.props;
    typeof onChange === 'function' && onChange({ 
      ...toJS(searchFormValue),
      [`${key}`]: value,
    });
    this.onSearch();
  }
  render() {
    const {
			prefixCls,
      caseListStore: {
        searchFormValue,
        tags: oldTags,
      },
      workflowChart,
		} = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    const type = [{
      typeName: '全部',
      id: 'default'
    }, {
      typeName: '代码类',
      id: 'code',
    }, {
      typeName: '文档类',
      id: 'doc'
    }];
    const platform = [{
      typeName: '全部',
      id: ''
    }, {
      typeName: 'PC',
      id: 'pc',
    }, {
      typeName: '移动端',
      id: 'mobile'
    },
    // {
    //   typeName: '全平台',
    //   id: 'all'
    // }
    ];
    const tags = [
      {
        id: '',
        typeName: '全部'
      },
      ...oldTags
    ];
    const sortList = [{
      label:  <span>
                最新
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'createdate',
    }, {
      label:  <span>
                最热
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'downloadcounts',
    }, {
      label:  <span>
                访问量
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'visits',
    }];
    const searchValues = toJS(searchFormValue);
    return (
			<div className={`${prefixCls}-header`}>
				<Form>
          {
            // !workflowChart && <Row className={`${prefixCls}-header-list`}>
            //   <SearchList 
            //     label="标签："
            //     className={`${prefixCls}-header-list-item`}
            //     datas={tags}
            //     radio
            //     selectKey={searchValues.tagId}
            //     onSelect={value => this.handleSelectChange(value, 'tagId')}
            //   />
            //   <SearchList
            //     label="类型："
            //     className={`${prefixCls}-header-list-item`}
            //     radio
            //     datas={type}
            //     selectKey={searchValues.demotype}
            //     onSelect={value => this.handleSelectChange(value, 'demotype')}
            //   />
            //   <SearchList
            //     label="平台："
            //     radio
            //     datas={platform}
            //     className={`${prefixCls}-header-list-item`}
            //     selectKey={searchValues.platform}
            //     onSelect={value => this.handleSelectChange(value, 'platform')}
            //   />
            //   {/* <SearchList
            //     label="排序："
            //     radio
            //     datas={orderby}
            //     selectKey={searchValues.orderby}
            //     onSelect={value => this.handleSelectChange(value, 'orderby')}
            //   /> */}
            // </Row>
          }
          {/* <Radio.Group 
            defaultValue={searchValues.orderby}
            buttonStyle="solid"
            className={`${prefixCls}-header-sort`}
            onChange={e => this.handleSelectChange(e.target.value, 'orderby')}
          >
            {
              orderby.map(value => 
                <Radio.Button 
                  value={value.id}
                  key={value.id}
                >
                  {value.typeName}
                </Radio.Button>
              )
            }
          </Radio.Group> */}
          <RadioSort
            datas={sortList}
            value={searchFormValue.orderby}
            className="main-workflow-sort"
            onChange={value => this.handleSelectChange(value, 'orderby')}
          />
				</Form>
			</div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/home/caseSearch/index.js